// extracted by mini-css-extract-plugin
export default {"cardWrapper":"nftCard_cardWrapper__xc7j4","textWrapper":"nftCard_textWrapper__J8CZs"};